<div class="card card-primary card-outline style">
  <div class="card-body box-profile">
    
      <img class="profile-user-img img-fluid img-square Position" src="assets/img/customer.png" alt="User profile picture">   
 </div>
   <!------------Add edit button----------------->
   <a class="btn btn-info btn-sm edit" (click)='getValue();EditCustomer();'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
  <!-------------------------------------------->
 <p class="style1">
      <b>{{name}}</b>
    </p>
    <div class="table-responsive">

      <div *ngFor="let c of output">
      <table class="table style">
      <tbody>
      
      <tr>
      <th style="width:30%">Customer Code:</th>
      <td>{{c.customer_code}}</td>
      </tr>

      <tr>
      <th>Email:</th>
      <td>{{c.customer_email}}</td>
      </tr>

      <tr>
      <th>Department:</th>
      <td>{{c.customer_department}}</td>
      </tr>

      <tr>
      <th>Responsible Employee:</th>
      <td>{{c.responsible_name}}</td>
      </tr>

      <tr>
      <th>Second Responsible:</th>
      <td>{{c.second_responsible_name}}</td>
      </tr>

      <tr>
      <th>Sales Eecutive Name:</th>
      <td>{{c.sales_executive_name}}</td>
      </tr>

      <tr>
      <th>Credit Limit:</th>
      <td>{{c.credit_limit}}</td>
      </tr>

      <tr>
      <th>Credit Balance:</th>
      <td>{{c.credit_balance}}</td>
      </tr>

      <tr>
      <th>Earliest Overdue:</th>
      <td>{{EarliestDate}}</td>
      </tr>

      <tr>
      <th>Oldest Due Date:</th>
      <td>{{OldestDate}}</td>
      </tr>

      <tr>
      <th>Oldest Due Sales Number:</th>
      <td>{{c.oldest_due_inv_number}}</td>
      </tr>

      <tr>
      <th>Total Due Amount:</th>
      <td>{{c.total_due_amount}}</td>
      </tr>

      <tr>
      <th>Contract:</th>
      <td>{{c.contract}}</td>
      </tr>

      <tr>
      <th>Company Price:</th>
      <td>{{c.company_price}}</td>
      </tr>

      <tr>
      <th>Payment Terms:</th>
      <td>{{c.payment_terms}}</td>
      </tr>

      <tr>
      <th>This Month Sales</th>
      <td>{{c.current_month_sales}}</td>
      </tr>

      <tr>
        <th>Last 3 months Sales:</th>
        <td>{{c.last_3_month_sales}}</td>
        </tr>

      </tbody></table>
      <p class="style2">
        <b>Last 3 month sales details:</b>
         </p>
      
         <div class="card">
          <div class="card-body" *ngFor="let d of c.last_3_month_sales_details">
         
            <strong class="distance1"> Current Month:</strong>{{d.current_month}}<br>
            <strong class="distance2">Last Month:</strong>{{d.last_month}}<br>
            <strong class="distance3">Month Before Last Month:</strong>{{d.month_before_last_month}}
            <hr>
          </div>
          
<!-------------------------------------------------------------------------------------->
<p class="style2">
  <b>Brands:</b>
   </p>
   <div class="card">
    <div class="card-body" *ngFor="let d of c.company_brands">
      <strong class="distance4"> Brand Name:</strong>{{d.brand_name}}<br>
      <hr>
    </div>
    
   

<!-------------------------------------------------------------------------------------->
<p class="style2">
  <b>Receipts For Last 3 Months</b>
   </p>

   <div class="card">
    <div class="card-body" *ngFor="let d of c.last_3_month_receipts">
   
      <strong class="distance1" (click)='ReceiptDetails();getReceiptValue(d.receipt_id)'> Receipt Number:</strong>{{d.receipt_number}}<br>
      <strong class="distance1"> Receipt Type:</strong>{{d.receipt_type}}<br>
      <strong class="distance1"> Total Amount:</strong>{{d.total_amount}}<br>
      <hr>
    </div>
<!-------------------------------------------------------------------------------------->
<p class="style2">
  <b>Visits:</b>
   </p>

   <div class="card">
    <div class="card-body" *ngFor="let d of c.visits">
   
      <strong class="distance1" (click)='CustomerVisitDetails();getVisitValue(d.customer_id)'>Customer Name:</strong>{{d.customer_name}}<br>
      <strong class="distance1">Employee Name:</strong>{{d.employee_name}}<br>
      <strong class="distance1">Visit Purpose:</strong>{{d.visit_purpose}}<br>
      <hr>
    </div>
    
    
<!--------------
<form class="center">
<h1>Customer Details</h1>
  <div class="settings" *ngFor="let c of output">

      <label>Customer Code:</label><label>{{c.customer_code}}</label>
      <label>Email:</label><label>{{c.customer_email}}</label>
      <label>Department:</label><label>{{c.customer_department}}</label>
       
      <label>Responsible Employee:</label><label>{{c.responsible_name}}</label>
      <label>Second Responsible:</label><label>{{c.second_responsible_name}}</label>
      <label>Sales Eecutive Name:</label><label>{{c.sales_executive_name}}</label>


      <label>Credit Limit:</label><label>{{c.credit_limit}}</label>
      <label>Credit Balance:</label><label>{{c.credit_balance}}</label>
      <label>Earliest Overdue:</label><label>{{EarliestDate}}</label>

      <label>Oldest Due Date:</label><label>{{OldestDate}}</label>
      <label>Oldest Due Sales Number:</label><label>{{c.oldest_due_inv_number}}</label>
      <label>Contract:</label><label>{{c.contract}}</label>
      <label>Company Price:</label><label>{{c.company_price}}</label>
      <label>Payment Terms:</label><label>{{c.payment_terms}}</label>
      <label>This Month Sales:</label><label>{{c.current_month_sales}}</label>
      <label>Last 3 months Sales:</label><label>{{c.last_3_month_sales}}</label>
  </div>
  </form>

  <div *ngFor="let c of output">
    <label class="colour">Last 3 month sales details</label><br>
    <ul *ngFor="let d of c.last_3_month_sales_details" class="nobull" >
      <li ><b>{{d.current_month}}</b></li>
      <li ><b>{{d.last_month}}</b></li>
      <li ><b>{{d.month_before_last_month}}</b></li>
    </ul>
  </div>

<div *ngFor="let c of output">
  <label class="colour">Brands</label><br>
  <ul *ngFor="let d of c.company_brands" class="nobull" >
    <li ><b>{{d.brand_name}}</b></li>
  </ul>
</div>
<div *ngFor="let c of output">
  <label class="colour">Receipts For Last 3 Months</label><br>
  <ul *ngFor="let d of c.last_3_month_receipts" class="nobull" >
    <li (click)='ReceiptDetails();getReceiptValue(d.receipt_id)' ><b>{{d.receipt_number}}</b></li>
    <li class="nobull">{{d.receipt_type}}</li>
    <li class="nobull">{{d.total_amount}}</li> <br>
  </ul>
</div>
<div *ngFor="let c of output">
  <label class="colour">Visits</label><br>
  <ul *ngFor="let d of c.visits" class="nobull" >
    <li (click)='CustomerVisitDetails();getVisitValue(d.customer_id)' ><b>{{d.customer_name}}</b></li>
    <li class="nobull">{{d.employee_name}}</li>
    <li class="nobull">{{d.visit_purpose}}</li> <br>
  </ul>
</div>
---->

